module.exports = __webpack_public_path__ + "static/garmin-pay-cd99e5fd1b81cf38a3cc01e046216987.png";